import { round } from 'lodash';
import moment from 'moment';
import compact from 'lodash/compact';

export const separateThousand = (num, digits = 3) => {
  if (!num) return '0';
  if (Number.isNaN(num)) return '0';
  const roundNum = round(Number(num), 2);
  const re = `\\B(?=(\\d{${digits}})+(?!\\d))`;
  return String(roundNum).replace(new RegExp(re, 'g'), ',');
};

export const inputNumberFormatter = () => {
  return {
    formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    parser: (value) => value.replace(/\\s?|(,*)/g, ''),
    ruleType: 'number',
  };
};

export const formatMoney = (number, n = 0, x = 3, subffix?: string) => {
  if (!number) return '0' + (subffix || 'đ');
  const re = `\\d(?=(\\d{${x}})+${n > 0 ? '\\.' : '$'})`;
  return (
    Number(number)
      .toFixed(Math.max(0, ~~n))
      .replace(new RegExp(re, 'g'), '$&,') + (subffix || ' đ')
  );
};

export const formatDateTime = (text, formatter = 'DD/MM/YY, hh:mma') => {
  return text ? moment(text).format(formatter) : moment().format(formatter);
};

export const formatDateTimeDisplay = (text) => {
  return text ? moment(text).format('DD/MM/YY, hh:mma') : null;
};

export const formatUserName = (user) => {
  // if(user?.username) return `@${user?.username}`;
  if (user?.firstName || user?.lastName)
    return `${user?.firstName || ''} ${user?.lastName || ''}`;
  return user?.email || user?.phone;
};

export const formatFullAddressCustomer = (item) => {
  return compact([
    item?.addressLine2,
    item?.addressLine1,
    item?.ward,
    item?.district,
    item?.province,
  ]).join(', ');
};

export const formatSignedNumber = (value) => (value < 0 ? 0 : value);

export const formatTextToSlug = (str) => {
  if (!str) return '';
  str = str.toLowerCase();
  str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a');
  str = str.replace(/[èéẹẻẽêềếệểễ]/g, 'e');
  str = str.replace(/[ìíịỉĩ]/g, 'i');
  str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o');
  str = str.replace(/[ùúụủũưừứựửữ]/g, 'u');
  str = str.replace(/[ỳýỵỷỹ]/g, 'y');
  str = str.replace(/đ/g, 'd');

  str = str.replace(/[^a-z0-9]/g, '-');

  str = str.replace(/-+/g, '-');

  str = str.replace(/^-|-$/g, '');

  return str;
};

export const formatMoneyWithCurrency = (
  number,
  currency = 'VND',
  n = 0,
  x = 3,
) => {
  const re = `\\d(?=(\\d{${x}})+${n > 0 ? '\\.' : '$'})`;
  if (currency === 'USD' || currency === '$') {
    return `$${Number(number)
      .toFixed(Math.max(0, ~~n))
      .replace(new RegExp(re, 'g'), `$&,`)}`;
    // .replace(new RegExp(re, 'g'), '$&. ');
  }
  return `${Number(number)
    .toFixed(Math.max(0, ~~n))
    .replace(new RegExp(re, 'g'), `$&,`)} ${currency}`;
  // .replace(new RegExp(re, 'g'), '$&.');
};

export const differentLabelChannels = ['shopee', 'tiktokshops', 'LEX'];

export const getTotalQuantiy = (items) => {
  let total = 0;

  items.forEach((e) => {
    total += e?.quantity;
  });

  return total;
};
